import { Link  } from "react-router-dom";

const TypedLink = (props) => {

  const link = props.link || null;

  const className = ((props.className) ? props.className : '')+''+((props.no_url) ? ' disable-link' : '');

  const onClick = (e)=>{

    if (props.disableClick) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if(typeof props.onClick == 'function'){
      props.onClick(e);
    }

  };

  const children = <>
    {!!link && !!link.title ? link.title : ''}
    {(props.children && !!props.children.length) ? props.children.map((element) => element) : ((typeof props.children === 'object') ? props.children : '')}
  </>;

  // modal típusú link: nem react-router Link, a megnyitást (és a navigációs fallbacket) a Layout globális link-kezelője végzi
  if (!!link && link.type === 'modal')
  {
    return <a className={className} onClick={(e)=>{onClick(e)}} data-type="modal" href={link.url || ''}>{children}</a>;
  }

  let to = '';

  if (link.type)
  {
    if (link.type[0] == '/') link.type = link.type.substring(1, link.type.length);
    to += '/' + link.type;
  }

  if (link.url)
  {
    if (link.url[0] == '/') link.url = link.url.substring(1, link.url.length);
    to += link.url[0] === '?' ? link.url : '/' + link.url;
  }

  return !!link
    ? <Link className={className} onClick={(e)=>{onClick(e)}} data-type={link.type} to={`${to}`}>
        {children}
      </Link>
    :  '';
};

export default TypedLink;
